import { render, staticRenderFns } from "./event_detail.vue?vue&type=template&id=b13b901c&scoped=true&"
import script from "./event_detail.vue?vue&type=script&lang=js&"
export * from "./event_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13b901c",
  null
  
)

export default component.exports